<div class="forgot-password-component">
        <div *ngIf="msg" role="alert" class="alert alert-error alert-dismissible">
            <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span class="sr-only">Error:</span>
            {{msg}}
        </div>
        <div class="container"
                    style="display: flex; flex-direction: row; gap: 10px; justify-content: center;">

            <mat-card *ngIf="!returned">
                <mat-card-title>
                    <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Forgot Password</h2>
                </mat-card-title>
                <mat-card-content>
                <form class="example-form" *ngIf="!currentTenant">
                    <mat-form-field>
                      <mat-label>Tenant Name</mat-label>
                        <input matInput  name="selectedTenant" [(ngModel)]="selectedTenant" />
                    </mat-form-field>
                </form>

                <form class="example-form">
                    <mat-form-field class="example-full-width">
                      <mat-label>Email Address</mat-label>
                        <input matInput  name="emailAddress" [(ngModel)]="emailAddress">
                    </mat-form-field>
                </form>

                <div class="example-form" *ngIf="user != null && user.secretQuestion1 != null">
                    <mat-form-field class="example-full-width">
                      <mat-label>Secret Question 1</mat-label>
                        <input matInput  [(ngModel)]="user.secretQuestion1" name="secretQuestion1" readonly>
                    </mat-form-field>

                    <form class="example-form">
                        <mat-form-field class="example-full-width">
                          <mat-label>Answer1</mat-label>
                            <input matInput  name="secretAnswer1" [(ngModel)]="user.secretAnswer1" >
                        </mat-form-field>
                    </form>
                </div>

                <form class="example-form" *ngIf="user != null && user.secretQuestion2 != null">
                    <mat-form-field class="example-full-width">
                      <mat-label>Secret Question 2</mat-label>
                        <input matInput  [(ngModel)]="user.secretQuestion2" name="secretQuestion2" readonly>
                    </mat-form-field>

                    <form class="example-form">
                        <mat-form-field class="example-full-width">
                          <mat-label>Answer 2</mat-label>
                            <input matInput  name="secretAnswer2" [(ngModel)]="user.secretAnswer2" >
                        </mat-form-field>
                    </form>
                </form>

                <div class="example-form" *ngIf="user != null && user.secretQuestion3 != null">
                    <mat-form-field class="example-full-width">
                      <mat-label>Secret Question 3</mat-label>
                        <input matInput  [(ngModel)]="user.secretQuestion3" name="secretQuestion3" readonly>
                    </mat-form-field>

                    <form class="example-form">
                        <mat-form-field class="example-full-width">
                          <mat-label>Answer 3</mat-label>
                            <input matInput  name="secretAnswer3" [(ngModel)]="user.secretAnswer3" >
                        </mat-form-field>
                    </form>
                </div>

                </mat-card-content>
                <mat-card-actions>
                        <div class="form-group">
                                <button mat-raised-button [disabled]="loading" style="border-radius: 6px;" (click)="onChangePassword()">Change password</button>
                                <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
                                <button mat-raised-button style="border-radius: 6px;" [routerLink]="['/login']">Cancel</button>
                            </div>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
